import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, CheckCircle2 } from 'lucide-react';
const names = ['María', 'Sofía', 'Carolina', 'Valentina', 'Luciana', 'Marcela', 'Laura', 'Ana', 'Juan', 'Diego', 'Martín', 'Lucas', 'Florencia', 'Camila', 'Agustina', 'Romina', 'Gabriela', 'Mariana'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'Salta', 'La Plata', 'Mar del Plata', 'San Juan', 'Neuquén', 'Bahía Blanca', 'Santa Fe', 'Jujuy', 'Posadas', 'Resistencia'];
const packs = ['Fuerza Mayor', 'Pack Completo', 'Pack Completo', 'Pack Completo']; // Weight towards Pack Completo
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: '',
    pack: '',
    time: 0
  });
  const generateRandomData = () => {
    const name = names[Math.floor(Math.random() * names.length)];
    const initial = name.charAt(0);
    const city = cities[Math.floor(Math.random() * cities.length)];
    const pack = packs[Math.floor(Math.random() * packs.length)];
    const time = Math.floor(Math.random() * 15) + 1; // 1 to 15 mins ago
    setData({
      name: `${name} L.`,
      city,
      pack,
      time
    });
  };
  useEffect(() => {
    // Show first popup after 10 seconds
    const initialTimer = setTimeout(() => {
      generateRandomData();
      setIsVisible(true);
    }, 10000);
    return () => clearTimeout(initialTimer);
  }, []);
  useEffect(() => {
    let hideTimer: NodeJS.Timeout;
    let nextShowTimer: NodeJS.Timeout;
    if (isVisible) {
      // Hide after 5 seconds
      hideTimer = setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    } else {
      // If not visible, schedule next show between 40-60 seconds
      // But only if it has been shown at least once (handled by initialTimer)
      // To prevent immediate trigger, we check if data.name exists
      if (data.name) {
        const nextInterval = Math.floor(Math.random() * (60000 - 40000 + 1)) + 40000;
        nextShowTimer = setTimeout(() => {
          generateRandomData();
          setIsVisible(true);
        }, nextInterval);
      }
    }
    return () => {
      clearTimeout(hideTimer);
      clearTimeout(nextShowTimer);
    };
  }, [isVisible, data.name]);
  return <AnimatePresence data-id="element-254">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-4 left-4 z-50 bg-white rounded-xl shadow-2xl border border-navy-100 p-4 pr-10 max-w-sm w-[calc(100%-2rem)] md:w-auto" data-id="element-255">
          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-navy-400 hover:text-navy-700 transition-colors" data-id="element-256">
            <X size={16} data-id="element-257" />
          </button>

          <div className="flex items-start gap-3" data-id="element-258">
            <div className="w-10 h-10 rounded-full bg-blue-600 text-white flex items-center justify-center font-bold text-lg shrink-0" data-id="element-259">
              {data.name.charAt(0)}
            </div>
            <div data-id="element-260">
              <div className="flex items-center gap-1 mb-1" data-id="element-261">
                <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse" data-id="element-262"></div>
                <span className="text-[10px] font-bold text-green-600 uppercase tracking-wider" data-id="element-263">
                  Compra Verificada
                </span>
              </div>
              <p className="text-sm text-navy-900 leading-tight" data-id="element-264">
                <strong data-id="element-265">{data.name}</strong> de {data.city} acaba de comprar el{' '}
                <strong data-id="element-266">{data.pack}</strong>
              </p>
              <p className="text-xs text-navy-500 mt-1 flex items-center gap-1" data-id="element-267">
                <CheckCircle2 size={12} className="text-green-500" data-id="element-268" />
                hace {data.time} {data.time === 1 ? 'minuto' : 'minutos'}
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}